export class Options {
  _schema = {
    posterMarker: "bool",
    mapCoordinates: "object",
    sportsRoutes: "object",
  };

  _query = {
    style: "posterStyle",
    coordinates: "mapCoordinates",
    kader: "posterKader",
    size: "posterSize",
    frame: "posterFrame",
    giftwrap: "posterGiftwrapSelect",
    orientation: "posterOrientation",
    coordinatesLabel: "sportsmapLocation",
    main: "sportsmapMain",
    subtitle: "sportsmapSubtitle",
    subtitle2: "sportsmapSubtitle2",
    sportsmapYear: "sportsmapYear",
    zoom: "mapZoom",
    routeColor: "routeColor",
    startColor: "startColor",
    endColor: "endColor",
    showEndPoints: "showEndPoints",
    labelsOverRoute: "labelsOverRoute",
    unlockMap: "unlockMap",
    geojsonString: "geojsonString",
    geojsonUrl: "geojsonUrl",
    routes: "sportsRoutes",
    routeThickness: "routeThickness",
    SMPosterStyle: "SMPosterStyle",
    SMFontStyle: "SMFontStyle",
    previousCartItemId: "previousCartItemId",
  };

  _options = {
    mapCoordinates: JSON.stringify([13.355054999999993, 52.47059945489795]),
    mapZoom: 11.25,
    settingsPanel: "map",
    posterSize: "small",
    posterFrame: "black",
    posterKader: "with",
    posterMarker: true,
    posterStyle: 2,
  };

  constructor() {
    this._searchParams = new URLSearchParams(window.location.search);
    // Flips the queries key and value
    this._queryMap = Object.assign(
      {},
      ...Object.entries(this._query).map(([a, b]) => ({ [b]: a })),
    );
    this._configData = null;
  }

  async init() {
    const configUrl = this._searchParams.get("configFileUrl");
    if (!configUrl) return;

    try {
      const response = await fetch(configUrl, { cache: "no-store" });
      if (!response.ok) {
        throw new Error(`Config gaf status ${response.status}`);
      }
      this._configData = await response.json();
    } catch (error) {
      console.error("Sportsmap-config kon niet worden geladen", error);
      this._configData = null;
    }
  }

  checkEncodeURI(str) {
    return /\%/i.test(str);
  }

  get(key, defaultValue = null, defaultType = null) {
    let type = this._schema[key] || defaultType;
    let value = this._getOption(key);

    if (value === undefined || value === null) {
      value = defaultValue;
    }

    if (!type) {
      return value || defaultValue;
    }

    if (type === "object" && value) {
      if (typeof value === "object") {
        return value;
      }

      if (this.checkEncodeURI(value)) {
        value = decodeURI(value);
      }

      return JSON.parse(value);
    }

    if (type === "split" && value) {
      return value.replace("[", "").replace("]", "").split(",");
    }

    if (type === "bool") {
      if (value === "true" || value === "1" || value === true) {
        return true;
      }

      if (value === "false" || value === "0" || value === false) {
        return false;
      }

      return this._options[key];
    }

    return value;
  }

  _getOption(key) {
    let value;
    let altKey = this._queryMap[key];

    // Try GET parameters
    value = this._searchParams.get(key);
    if (value !== null) return value;

    // Try GET parameters with custom name
    value = this._searchParams.get(altKey);
    if (value !== null) return value;

    // Try the remotely stored poster config
    if (this._configData) {
      if (Object.prototype.hasOwnProperty.call(this._configData, key)) {
        return this._configData[key];
      }

      if (
        altKey &&
        Object.prototype.hasOwnProperty.call(this._configData, altKey)
      ) {
        return this._configData[altKey];
      }
    }

    // Try Local storage
    value = localStorage.getItem(key);
    if (value !== null) return value;

    // Return default value
    return this._options[key] || this._options[altKey];
  }

  _getQuery() {}

  all() {
    return this._options;
  }
}
